import { FiCreditCard } from 'react-icons/fi'

const PayDues = () => (
  <section className="dash-card empty-state-card">
    <span><FiCreditCard /></span>
    <h2>Online dues are coming soon</h2>
    <p>This section is being prepared for secure association payments. No action is needed here yet.</p>
  </section>
)

export default PayDues;
